export const CREATE_STOCK16371 = "CREATE_STOCK16371";
export const UPDATE_STOCK16371 = "UPDATE_STOCK16371";
export const DELETE_STOCK16371 = "DELETE_STOCK16371";
export const FETCH_STOCK16371 = "FETCH_STOCK16371";
export const LISTEN_TO_SELECTED_STOCK16371 = "LISTEN_TO_SELECTED_STOCK16371";
